import { React } from "react";
import AddVehicleCustomDropdown from "../../../../../../ManageOrders/OrderDetails/OrderModals/AddPaymentModal/AddVehicleCustomDropdown";
import { Col, Typography, Avatar } from "antd";

const Text = Typography;

const SellerVehicleRequest = ({
  vehiclesmaster,
  addVehicleFormData,
  setAddVehicleFormData,
}) => {
  const vehicleTypeVisible = (id) => {
    const updatedVehicles = addVehicleFormData.map((vehicle) =>
      vehicle.id === id
        ? {
            ...vehicle,
            vehicleVisible: vehicle.vehicleVisible === true ? false : true,
          }
        : vehicle
    );
    setAddVehicleFormData(updatedVehicles);
  };

  const handleVehcileTypeClick = (selectedValue, id) => {
    const selectedVehicle = vehiclesmaster?.find((option) => {
      return option.vechicle_type === selectedValue;
    });
    const updatedVehicles = addVehicleFormData.map((vehicle) =>
      vehicle.id === id
        ? {
            ...vehicle,
            vechicle_type: selectedValue,
            vechicle_type_Id: selectedVehicle.id,
            vechicle_image: selectedVehicle.vechicle_image,
            vechicle_weight: selectedVehicle.vechicle_weight,
            vechicle_storage: selectedVehicle.vechicle_storage,
            vehicleVisible: !selectedVehicle.vechicle_storage,
          }
        : vehicle
    );
    setAddVehicleFormData(updatedVehicles);
  };

  return (
    <>
      {addVehicleFormData.map((vehicle) => (
        <Col key={vehicle.id}>
          <Col className="add-vehicle-type-wrapper" style={{ gap: "10px" }}>
            <Col className="dropdown-wrapper" style={{ minWidth: "55%" }}>
              <AddVehicleCustomDropdown
                handleOptionClick={handleVehcileTypeClick}
                visible={vehicle?.vehicleVisible}
                handleVisibleChange={vehicleTypeVisible}
                selectedText={vehicle?.vechicle_type}
                options={vehiclesmaster}
                id={vehicle.id}
              />
            </Col>
          </Col>
          {vehicle?.vechicle_type &&
            vehicle?.vechicle_type !== "SELECT VEHICLE" && (
              <Col className="vehicle-disc-wrapper">
                <Avatar
                  shape="square"
                  src={vehicle?.vechicle_image}
                  className="vehicle-icon"
                />

                <Col className="vehicle-disc">
                  <Col className="vehicle-disc-align">
                    <Col style={{ width: "60%" }}>
                      <Text
                        className="vehicle-disc-key"
                        style={{ width: "unset" }}
                      >
                        Maximum shipment weight:
                      </Text>
                    </Col>
                    <Text
                      className="text-right vehicle-disc-key text-bold"
                      style={{ width: "40%" }}
                    >
                      {vehicle?.vechicle_weight}
                    </Text>
                  </Col>
                  <Col className="vehicle-disc-align">
                    <Col style={{ width: "55%" }}>
                      <Text
                        className="vehicle-disc-key "
                        style={{ width: "unset" }}
                      >
                        Vehicle storage (LxBxH):
                      </Text>
                    </Col>
                    <Text
                      className="text-right vehicle-disc-key text-bold"
                      style={{ width: "45%" }}
                    >{`${vehicle?.vechicle_storage} cm`}</Text>
                  </Col>
                </Col>
              </Col>
            )}
          <Col className="important-notes-alert">
            <Col className="note-item">
              <Text className="note-text-static">
                Only one vehicle can be booked per order. Choose a vehicle that
                fits your complete order. For additional vehicles, please reach
                out to customer support.
              </Text>
            </Col>
          </Col>
        </Col>
      ))}
    </>
  );
};
export default SellerVehicleRequest;
